/* eslint-disable complexity */
(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name webAgro1App.CorrecoesSoloService
   * @description
   * # CorrecoesSoloService
   * Factory in the webAgro1App.
   */
  angular
    .module('webAgro1App')
    .factory('CorrecoesSoloService', CorrecoesSoloService);

  CorrecoesSoloService.$inject = [
    '$http',
    '$rootScope'
  ];

  // eslint-disable-next-line max-lines-per-function
  function CorrecoesSoloService($http, $rootScope) {
    //////////////////////////////////////////
    // Service data

    //////////////////////////////////////////
    // Service object declaration
    return {
      list: List,
      getStatusCorrecaoGlebas: GetStatusCorrecaoGlebas,
      get: Get,
      delete: Delete
    };

    //////////////////////////////////////////
    // Function declarations

    function GetFilters(filters) {
      const operacoes = _.compact([
        $rootScope.parametros.operacao_correcao_solo.id,
        _.get($rootScope.parametros.operacao_adubacao_sistema, 'id')
      ]).join(',');

      return !filters ? {} : {
        data_inicial: filters.dataInicial || null,
        data_final: filters.dataFinal || null,
        page: filters.page || null,
        gleba: (filters.gleba || {}).id || null,
        operacao: operacoes,
        epoca: (filters.epoca || {}).codigo,
        status: filters.status || null
      };
    }

    function List(filters) {
      const params = GetFilters(filters);
      return $http.get(`${SERVER }v1/aplicacoes/simple`, { params: params });
    }

    function GetStatusCorrecaoGlebas(filters) {
      return $http.get(`${SERVER + API_VERSION }aplicacoes_status_glebas`, { params: GetFilters(filters) });
    }

    function Get(id) {
      return $http.get(`${SERVER }v1/aplicacoes/${ id}`);
    }

    function Delete(id) {
      return $http.delete(`${SERVER }v1/aplicacoes/${ id}`);
    }
  }
}());
